import { IPlayer } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export type UpdatePlayerPayload = {
  id: number;
  paylod: FormData;
};

export const UpdatePlayer = async (params: UpdatePlayerPayload): Promise<IPlayer> =>
  provider.Request("/players/{id}", params);
